import { Helmet } from 'react-helmet-async';

export const HelmetBlock = ({ title, description, path }) => {
  return (
    <Helmet>
      <title>{title ?? 'TOWER RECORDS SHIBUYA'}</title>
      <meta name="description" content={description ?? 'タワーレコード渋谷のリニューアルサイトです'} />
      <link rel="canonical" href={`https://towershibuya.jp/${path ?? ''}`} />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    </Helmet>
  );
};
